/**
 * Timeout value in milliseconds for timeline requests.
 * If the local timeline request takes longer than this value,
 * the system will fall back to requesting the cloud timeline.
 */
export const LOCAL_TIMELINE_TIMEOUT = 6000;
